import { TenantDto } from '@admin/app/api'
import { TenantStore } from '@admin/stores/tenant.store'
import { action, computed, makeObservable, observable } from 'mobx'

export class TenantUIStore {
  toBeRemoveTenantId?: number
  selectedTenantId?: number

  constructor(public store: TenantStore) {
    makeObservable(this, {
      toBeRemoveTenantId: observable,
      selectedTenantId: observable,
      tenants: computed,
      selectedTenant: computed,
      setToBeRemoveTenantId: action,
      setSelectedTenantId: action,
    })
  }

  get tenants() {
    return [...this.store.items].sort((a, b) => a.id - b.id)
  }

  get selectedTenant() {
    return this.store.items.find(tenant => tenant.id === this.selectedTenantId)
  }

  public setSelectedTenantId(tenantId?: number) {
    this.selectedTenantId = tenantId
  }

  isUnique(dto: TenantDto) {
    return (
      this.store.items.filter(e => dto.name.toUpperCase() == e.name.toUpperCase() && dto.id != e.id)
        .length == 0
    )
  }

  public setToBeRemoveTenantId(toBeRemoveTenantId?: number) {
    this.toBeRemoveTenantId = toBeRemoveTenantId
  }
}
